import type {
    DeleteSignalModalProps,
} from "app/pages/sales-intelligence/sub-modules/signals/components/modals/DeleteSignalModal/DeleteSignalModal";
import DeleteSignalModal from "app/pages/sales-intelligence/sub-modules/signals/components/modals/DeleteSignalModal/DeleteSignalModal";
import type SignalFilters from "app/pages/sales-intelligence/sub-modules/signals/models/core/SignalFilters";
import type UISignal from "app/pages/sales-intelligence/sub-modules/signals/models/view/UISignal";
import trackingService from "app/pages/sales-intelligence/sub-modules/signals/services/tracking/trackingService";

const DeleteSignalModalTracked = (props: DeleteSignalModalProps) => {
    function handleSubmitTrackedClick(signal: UISignal<SignalFilters>) {
        trackingService.management.trackDeleteSignalEvent("submit delete");
        props.onSubmitClick(signal);
    }

    function handleCloseTrackedClick() {
        trackingService.management.trackDeleteSignalEvent("cancel delete");
        props.onClose();
    }

    return (
        <DeleteSignalModal
            {...props}
            onSubmitClick={handleSubmitTrackedClick}
            onClose={handleCloseTrackedClick}
        />
    );
}

export default DeleteSignalModalTracked;
